var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAw = function SvgAw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#108a367f-3abb-444e-95dd-c4a4f412e726a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c926dd8e-8942-4994-929e-c88f6df14136b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c926dd8e-8942-4994-929e-c88f6df14136b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D87E0",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4062F",
    fillRule: "evenodd",
    d: "M4.485 4.485C5.355 4.43 6 4.235 6 4s-.645-.43-1.515-.485C4.43 2.645 4.235 2 4 2s-.43.645-.485 1.515C2.645 3.57 2 3.765 2 4s.645.43 1.515.485C3.57 5.355 3.765 6 4 6s.43-.645.485-1.515",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.485 4.485C5.355 4.43 6 4.235 6 4s-.645-.43-1.515-.485C4.43 2.645 4.235 2 4 2s-.43.645-.485 1.515C2.645 3.57 2 3.765 2 4s.645.43 1.515.485C3.57 5.355 3.765 6 4 6s.43-.645.485-1.515m.03.5.47-.47C4.91 5.713 4.66 6.5 4 6.5s-.91-.788-.984-1.984l.468.468C2.288 4.91 1.5 4.66 1.5 4s.788-.91 1.984-.984l-.468.468C3.09 2.288 3.34 1.5 4 1.5s.91.788.984 1.984l-.468-.468C5.712 3.09 6.5 3.34 6.5 4s-.788.91-1.984.984z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAD800",
    fillRule: "evenodd",
    d: "M0 9h21v1H0zm0 2h21v1H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "108a367f-3abb-444e-95dd-c4a4f412e726a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgAw;